var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Button, { IconButton } from '@doordash/component-button';
import { useToast } from '@doordash/component-toast';
import { Icon, Text, Stack, StackChildren, InlineChildren, } from '@doordash/design-language';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { PORTAL_ROUTE_PREFIX, DEFAULT_GROUP_MEMBERS_PAGE_SIZE, } from '../../constants/values';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import styled from 'styled-components';
import { fetchTeamAccountGroupById } from '../Groups/groups_slice';
import { fetchTeamAccountGroupMembers } from './groups_members_slice';
import track from '../../utils/track';
import { getStatusForAction as getStatusForGroupsAction, getTeamAccountGroups, } from '../Groups/groups_selector';
import { getStatusForAction as getStatusForGroupsMembersAction, getGroupsMembers, getMembersPagination, } from './groups_members_selector';
import { GroupsMembersList } from './groups_members_list';
import { GroupsMembersActions, GroupActions } from '../../constants/actions';
import { FetchStatus, INITIAL_FETCH_STATUS } from '../../constants/fetch_status';
import RemoveGroupMemberModal from './modals/remove_group_member_modal';
import { displayAddGroupMembersSuccessToast } from './modals/add_members_to_group_modal';
import AdminPageEmptyState from '../admin_page_empty_state';
import { GroupMembersPageTestId } from '../testId';
import { GroupsMembersEvents } from '../../constants/events';
import { AUTO_OPEN_ADD_MEMBER_QUERY_STRING } from '../Groups/values';
import BulkAddMembersToGroupModal from './modals/bulk_add_members_to_group_modal';
import { getSelectedTeamAccountContent } from '../../selectors/uiSelector';
import { useTeamAccountConfigurationContext } from '../TeamAccountPlanDetails/TeamAccountConfigurationContext';
import { getMembersPagination as getTeamAccountMembersPagination } from '../../selectors/members_selector';
import { fetchMembers } from '../members_slice';
export var AddMembersButtonContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 200px;\n"], ["\n  max-width: 200px;\n"])));
var findGroupById = function (groups, id) {
    return groups.find(function (group) { return group.id === id; });
};
export var GroupsMembersListContainer = function (_a) {
    var _b = _a.match.params, teamAccountId = _b.teamAccountId, _c = _b.page, page = _c === void 0 ? '1' : _c, groupId = _b.groupId, history = _a.history;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var location = useLocation();
    var searchParams = queryString.parse(location.search);
    var autoOpenedModal = React.useRef(false);
    var groups = useSelector(getTeamAccountGroups);
    var _d = __read(React.useState(null), 2), currentGroup = _d[0], setCurrentGroup = _d[1];
    var groupsMembers = useSelector(getGroupsMembers);
    var groupsMembersPagination = useSelector(getMembersPagination);
    var statusForGroupsAction = useSelector(getStatusForGroupsAction);
    var statusForMembersAction = useSelector(getStatusForGroupsMembersAction);
    var _e = __read(React.useState(null), 2), removeModalProps = _e[0], setRemoveModalProps = _e[1];
    var _f = __read(React.useState(null), 2), addModalProps = _f[0], setAddModalProps = _f[1];
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    var _g = useTeamAccountConfigurationContext(), maxMembersLimit = _g.maxMembersLimit, hasMaxMembersLimit = _g.hasMaxMembersLimit;
    var totalMembersCount = useSelector(getTeamAccountMembersPagination).totalCount;
    var fetchGroup = React.useCallback(function () { return dispatch(fetchTeamAccountGroupById(groupId)); }, [dispatch, groupId]);
    var fetchGroupMembers = React.useCallback(function () { return dispatch(fetchTeamAccountGroupMembers({ groupId: groupId, pageNumber: page })); }, [dispatch, groupId, page]);
    var fetchTeamAccountMembersCount = React.useCallback(function () {
        return dispatch(fetchMembers({ teamAccountId: teamAccountId, pageNumber: '1', pageSize: 1 }));
    }, [dispatch, teamAccountId]);
    var displaySuccessToast = function (group, options) { return displayAddGroupMembersSuccessToast(group, options, displayToast); };
    React.useEffect(function () {
        track(GroupsMembersEvents.GROUPS_MEMBERS_LIST);
    }, []);
    React.useEffect(function () {
        fetchGroup();
        fetchGroupMembers();
    }, [fetchGroup, fetchGroupMembers]);
    React.useEffect(function () {
        // when an account has a limit and the total members count is not yet retrieved
        if (hasMaxMembersLimit && !totalMembersCount) {
            fetchTeamAccountMembersCount();
        }
    }, [fetchTeamAccountMembersCount, hasMaxMembersLimit, totalMembersCount]);
    React.useEffect(function () {
        var _a, _b;
        if (((_a = statusForGroupsAction[GroupActions.FETCH_TEAM_ACCOUNT_GROUP_BY_ID]) === null || _a === void 0 ? void 0 : _a.status) === FetchStatus.FULFILLED) {
            var currentGroup_1 = findGroupById(groups, groupId) || null;
            setCurrentGroup(currentGroup_1);
            if (((_b = searchParams === null || searchParams === void 0 ? void 0 : searchParams[AUTO_OPEN_ADD_MEMBER_QUERY_STRING]) !== null && _b !== void 0 ? _b : '') === 'true' &&
                currentGroup_1 &&
                !autoOpenedModal.current) {
                autoOpenedModal.current = true;
                setAddModalProps({ group: currentGroup_1 });
            }
        }
    }, [statusForGroupsAction, groups, groupId, searchParams]);
    var isFetchStatusPending = function () {
        var _a, _b;
        return [INITIAL_FETCH_STATUS, FetchStatus.PENDING].includes((_a = statusForMembersAction[GroupsMembersActions.FETCH_TEAM_ACCOUNT_GROUP_MEMBERS]) === null || _a === void 0 ? void 0 : _a.status) ||
            [INITIAL_FETCH_STATUS, FetchStatus.PENDING].includes((_b = statusForGroupsAction[GroupActions.FETCH_TEAM_ACCOUNT_GROUP_BY_ID]) === null || _b === void 0 ? void 0 : _b.status);
    };
    var isFetchStatusError = function () {
        var _a, _b;
        return [FetchStatus.INVALID_STATUS, FetchStatus.REJECTED].includes((_a = statusForMembersAction[GroupsMembersActions.FETCH_TEAM_ACCOUNT_GROUP_MEMBERS]) === null || _a === void 0 ? void 0 : _a.status) ||
            [FetchStatus.INVALID_STATUS, FetchStatus.REJECTED].includes((_b = statusForGroupsAction[GroupActions.FETCH_TEAM_ACCOUNT_GROUP_BY_ID]) === null || _b === void 0 ? void 0 : _b.status);
    };
    var onPageChange = React.useCallback(function (_a) {
        var requestedPage = _a.requestedPage;
        var newUrl = PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/groups/" + groupId + "/" + requestedPage;
        history.push(newUrl);
    }, [history]);
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, { size: Stack.Sizes.XLarge },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.FlexStart, alignItems: InlineChildren.Alignment.Center },
                    React.createElement(Link, { to: PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/groups/" },
                        React.createElement(IconButton, { accessibilityLabel: "All Groups", iconType: IconButton.IconTypes.ArrowLeft, "data-testid": GroupMembersPageTestId.GroupMembersPageBackButton })),
                    React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
                        React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium, overflow: Text.Overflows.BreakWord }, (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.name) || ''),
                        React.createElement(Text, { color: Text.Colors.TextTertiary },
                            groupsMembersPagination.totalCount,
                            " members"))),
                React.createElement(AddMembersButtonContainer, null,
                    React.createElement(Button, { onClick: function () {
                            setAddModalProps({ group: currentGroup });
                        }, type: Button.Types.PrimaryPill, "data-testid": GroupMembersPageTestId.GroupMembersPageAddMembersButton }, "Add Members"),
                    addModalProps && addModalProps.group && (React.createElement(BulkAddMembersToGroupModal, { teamAccount: teamAccount, teamAccountPlanMembersInfo: {
                            maxMembersLimit: (maxMembersLimit === null || maxMembersLimit === void 0 ? void 0 : maxMembersLimit.limit) || null,
                            totalMembersCount: totalMembersCount,
                        }, group: addModalProps.group, onClose: function () { return setAddModalProps(null); }, onSuccess: function (group, options) {
                            displaySuccessToast(group, options);
                            fetchGroupMembers();
                        } })),
                    removeModalProps && removeModalProps.group && (React.createElement(RemoveGroupMemberModal, { group: removeModalProps.group, groupMember: removeModalProps.groupMember, onGroupMemberRemoved: function () {
                            fetchGroupMembers(); // refresh groups member list on delete
                        }, onClose: function () { return setRemoveModalProps(null); } }))))),
        isFetchStatusError() ? (React.createElement(AdminPageEmptyState, { icon: React.createElement(Icon, { type: Icon.Types.WarningTriangleLine }), title: "Error loading group members", subtitle: "" })) : (currentGroup && (React.createElement(GroupsMembersList, { group: currentGroup, members: groupsMembers, page: page || '1', totalCount: groupsMembersPagination.totalCount, pageSize: DEFAULT_GROUP_MEMBERS_PAGE_SIZE, onPageChange: onPageChange, isLoading: isFetchStatusPending(), onRemoveMemberClick: function (groupMember, group) {
                return setRemoveModalProps({ groupMember: groupMember, group: group });
            } })))));
};
export default GroupsMembersListContainer;
var templateObject_1;
